module.exports = __webpack_public_path__ + "dcc5b47f0edff6b614a2e0f5b0f8208a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-20.png
// module id = 2941
// module chunks = 0